import {Menu, Dropdown, Icon} from 'antd';
import React from 'react';
import {connect} from 'react-redux';
import {updateIntl} from 'react-intl-redux'
import {LanguageService} from '../../services/LanguageService'
import configs from '../../constants/Configs';

class Languages extends React.Component {

    changeLanguage = ({key}) => {
        // Set selected language in local storage
        LanguageService.setSelectedLanguage(key);
        const translation = LanguageService.getTranslation(key);

        this.props.dispatch(updateIntl(translation));
        window.location.reload();
    }

    render() {
        const languages = LanguageService.supportedLanguges;
        //Convert languages dictionary to array
        // Add partner languages in Configs.js LANGUAGES array.
        const languagesArray = Object.keys(languages).map((key) => languages[key])
            .filter(val => configs.LANGUAGES.includes(val.key));

        //Check if language is farsi add classname
        const farsiLanguages = ['fa', 'ar'];

        if (farsiLanguages.indexOf(LanguageService.getSelectedLanguage()) !== -1) {
            document.body.classList.add('ta--rtl');
        } else {
            document.body.classList.contains('ta--rtl') && document.body.classList.remove('ta--rtl');
        }

        //Build menu items
        let listItems = languagesArray.map((language) =>
            <Menu.Item key={language.key}>
                {/* <i className={'flag ' + language.code} />  */}
                {language.name}
            </Menu.Item>
        );

        //Build menu
        const menu = (
            <Menu onClick={this.changeLanguage} className="f16">
                {listItems}
            </Menu>
        );

        return (
            <Dropdown overlay={menu} trigger={['click']}>
                <a className="ta--header-lang">
                    {languages[this.props.intl.locale].name} <Icon type="down"/>
                </a>
            </Dropdown>
        );
    }
}


const mapStateToProps = state => {
    return {
        intl: state.intl,
        user: state.user
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch,
        /*setLanguage: (langCode) => {
            // Set selected language in local storage
            LanguageService.setSelectedLanguage(langCode);
            const translation = LanguageService.getTranslation(langCode);

            dispatch(updateIntl(translation));
        }*/
    });
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Languages);






// WEBPACK FOOTER //
// ./src/components/languages/index.js